import React from 'react';
import CaseList from '../CaseList';
// @ts-ignore
import styles from './../CaseList.module.scss';
import useCases from '../../../Hooks/useCases';
import { useLazyWorkplaceCasesQuery } from '../../../../../graphql/graphql';
import SurveillanceCenterFilter from './SurveillanceCenterFilter';
import CaseListItem from '../CaseListItem';
import useFlatData from '../../../../Base/Hooks/useFlatData';
import useSocket from '../../../../Base/Hooks/useSocket';
import { Socket } from '../../../../Base/Enums/Socket.enum';

const SurveillanceCenterList: React.FC = () => {
	const [getWorkplaceCasesQuery, { data, isLoading }] =
		useLazyWorkplaceCasesQuery();
	const { getWorkplaceCases, getNextPage, page, setPage } = useCases(
		getWorkplaceCasesQuery,
	);
	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getWorkplaceCases,
		{
			data: data?.workplaceCases?.data,
			totalPages: data?.workplaceCases?.meta?.totalPages,
			page: data?.workplaceCases?.meta?.page,
		},
		page,
		setPage,
	);

	useSocket(Socket.CASE_TAKEN, loadData);

	return (
		<div className={styles.wrapper}>
			<SurveillanceCenterFilter onFilter={filter => setFilter(filter)} />
			<CaseList
				flatData={flatData}
				onLoadMore={getNextPage}
				onRefresh={loadData}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				renderItem={item => (
					<CaseListItem
						item={item}
						onRefresh={loadData}
						showWorkplace
						showAssignedDoctor
					/>
				)}
			/>
		</div>
	);
};

export default SurveillanceCenterList;
